// The window and document that own the screen the leaderboard is shown on:
// the host page's when the frame is same-origin (our portal), our own on the
// manager site (no frame) and on a foreign host, where reading
// window.top.document throws. Every host-aware helper derives from this one
// probe; leaderboards_v2/utils/visible_slice explains the foreign case.

// The host document, or null when it is out of reach.
export const hostDocument = () => {
  try {
    return window.top?.document ?? null
  } catch (error) {
    return null
  }
}

// The host window when reachable, else our own.
export const hostWindow = () => (hostDocument() ? window.top : window)
